// Check if the custom element 'gallery-slider' is not already defined
if (!customElements.get('gallery-slider')) {
  class GallerySlider extends HTMLElement {
    constructor() {
      super();

      this.sliderEle = this.querySelector('.swiper'); // Get the main swiper container
      this.sliderPagination = this.sliderEle?.querySelector('.swiper-pagination'); // Get the pagination element
      this.swiperInstance = null; // Initialize Swiper instance variable

      // Initialize the mobile slider on component creation
      this.initMobileSlider();

      // Bind the 'onResize' method to the instance to maintain proper context
      this.onResize = this.onResize.bind(this);

      // Listen for window resize events to handle slider adjustments
      window.addEventListener('resize', this.onResize);
    }

    // Method to destroy the mobile slider instance
    destroyMobileSlider() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    // Method to initialize the mobile slider instance based on window width
    initMobileSlider() {
      if (window.innerWidth <= 767) {
        // Create a new Swiper instance for mobile view
        this.swiperInstance = new Swiper(this.sliderEle, {
          slidesPerView: 1.18,
          grabCursor: true,
          centeredSlides: true,
          pagination: {
            el: this.sliderPagination,
            clickable: true
          }
        });
      }
    }

    // Method to handle slider adjustments on window resize
    onResize() {
      if (window.innerWidth >= 767) {
        // Destroy the mobile slider if window width exceeds the threshold
        this.destroyMobileSlider();
      } else {
        // If no Swiper instance exists, initialize the mobile slider
        if (!this.swiperInstance) {
          this.initMobileSlider();
        }
      }
    }

    // Callback triggered when the element is inserted into the DOM
    connectedCallback() {
      this.onResize();
    }

    // Callback triggered when the element is removed from the DOM
    disconnectedCallback() {
      // Remove the resize event listener and destroy the slider instance
      window.removeEventListener('resize', this.onResize);
      this.destroyMobileSlider();
    }
  }
  customElements.define('gallery-slider', GallerySlider);
}